import { render, staticRenderFns } from "./PD6060.vue?vue&type=template&id=1200e7d0&scoped=true&"
import script from "./PD6060.vue?vue&type=script&lang=js&"
export * from "./PD6060.vue?vue&type=script&lang=js&"
import style0 from "./PD6060.vue?vue&type=style&index=0&id=1200e7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200e7d0",
  null
  
)

export default component.exports